<template>
  <div class="mb-6">
    <v-row>
      <v-col cols="12">
        <h3>{{ label }}</h3>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          v-model="leadTimeSelection"
          :items="leadTimeOptions"
          label="Cutoff Day"
          hide-details
          dense
          outlined
        />
        <v-text-field
          v-if="leadTimeSelection == leadTimeOptions[2]"
          v-model="leadTimeDays"
          class="mt-2"
          label="Lead Time Days"
          type="number"
          min="0"
          max="30"
          step="1"
          :suffix="'day' + (leadTimeDays == 1 ? '' : 's') + ' before'"
          hide-details
          clearable
          @click:clear="leadTimeSelection = leadTimeOptions[0]"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-dialog v-model="showCutoffTimePicker" v-bind:width="300">
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="cutoffTimeInAmPm"
              label="Cutoff Time"
              v-on="on"
              readonly
              type="text"
              hide-details
              outlined
              dense
              prefix="at"
            />
          </template>
          <v-time-picker
            v-model="cutoffTime"
            label="Cutoff Time"
            format="ampm"
          />
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 py-0">
        <div class="text-center">
          An Item with date {{ exampleDateFormatted }} cuts off at
          <span class="font-weight-bold">
            {{ exampleCutoffFormatted }}</span
          ></div
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { format } from 'date-fns'

const leadTimeOptions = ['Day of', 'Day before', 'Custom...']

export default {
  name: 'ShopSettingsLeadTime',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: 'Lead Time',
    },
  },
  components: {},
  mounted() {
    this.leadTimeMinutes = this.value
    let leadTimeDays = Math.floor(this.value / 24 / 60)
    let selectionIndex = leadTimeDays >= 2 ? 2 : leadTimeDays
    this.leadTimeSelection = this.leadTimeOptions[selectionIndex]
    this.$nextTick(() => {
      this.leadTimeDays = leadTimeDays
    })
    if (this.value <= 1) {
      this.cutoffTime = '23:59'
    } else {
      this.cutoffTime = this.calculateCutoffTime()
    }
  },
  data() {
    return {
      showCutoffTimePicker: false,
      leadTimeDays: 1,
      cutoffTime: '12:00',
      leadTimeMinutes: 0,
      exampleDate: new Date().setHours(23, 59, 0, 0),
      leadTimeSelection: leadTimeOptions[0],
      leadTimeOptions,
    }
  },
  computed: {
    totalLeadTimeInMinutes() {
      return this.leadTimeDays * 24 * 60 + this.minutesBeforeMidnight
    },
    cutoffTimeInAmPm() {
      let cutoffDate = new Date()
      cutoffDate.setHours(
        this.cutoffTime.split(':')[0],
        this.cutoffTime.split(':')[1]
      )
      return format(cutoffDate, 'h:mm a')
    },
    minutesBeforeMidnight() {
      let timeParts = this.cutoffTime.split(':')
      let cutoffTimeConvertedToMinutes =
        timeParts[0] * 60 + Number(timeParts[1])
      let minutesInADay = 24 * 60
      let minutesBeforeMidnight = minutesInADay - cutoffTimeConvertedToMinutes
      return minutesBeforeMidnight
    },
    exampleDateFormatted() {
      return format(new Date(this.exampleDate), 'MMM d, yyyy')
    },
    exampleCutoffFormatted() {
      let exampleDateMinusCutoffTime = new Date(this.exampleDate)
      exampleDateMinusCutoffTime.setMinutes(
        exampleDateMinusCutoffTime.getMinutes() -
          this.totalLeadTimeInMinutes +
          1
      )
      return format(exampleDateMinusCutoffTime, 'MMM d, yyyy h:mm a')
    },
  },
  methods: {
    ...mapActions('shop', ['updateSetting']),
    calculateCutoffTime() {
      let numberMinutesInADay = 24 * 60
      let minutesBeforeMidnight = this.value % numberMinutesInADay
      let cutoffTime = new Date()
      cutoffTime.setHours(0, 0, 0, 0)
      cutoffTime.setMinutes(cutoffTime.getMinutes() - minutesBeforeMidnight)
      cutoffTime = format(cutoffTime, 'HH:mm')
      return cutoffTime
    },
  },
  watch: {
    totalLeadTimeInMinutes(value) {
      this.$emit('update', value)
    },
    leadTimeSelection(value) {
      this.leadTimeDays = this.leadTimeOptions.indexOf(value)
    },
  },
}
</script>
